import type { LongCopy } from '../copy'

export const de: LongCopy = {
  home: { title: 'Planet ABV Develop', lead: 'Hier leben unser Team und unsere Kompetenzen. Um ihn kreisen die Monde der Abteilungen, weiter draußen die Planeten der Projekte, die wir gebaut haben. Wählen Sie Ihr Ziel.', cta: 'Flugauftrag senden' },
  team: {
    analytics: {
      name: 'Systemanalyse',
      tagline: 'Wir übersetzen Business in Systeme',
      about: 'Hier beginnt jedes Projekt. Unsere Analysten verstehen, wie das Geschäft des Kunden wirklich funktioniert, und machen daraus Anforderungen, Prozessdiagramme und API-Verträge — damit das Team ohne Rätselraten baut.',
      facts: ['Erst den Prozess verstehen — dann Code schreiben', 'Anforderungen, Prozesslandkarten, Interface-Prototypen', 'API-Verträge stehen vor dem Entwicklungsstart'],
      soon: 'Bald finden Sie hier Neuigkeiten und Entdeckungen des Analyse-Teams',
    },
    ai: {
      name: 'KI-Engineering',
      tagline: 'Intelligenz für echte Arbeitsabläufe',
      about: 'Das Team entwickelt KI-Agenten, Suche über Unternehmensdaten, Dokumentenerkennung und MCP-Anbindungen an Assistenten — damit KI einem echten Prozess dient und nicht nur einer Demo.',
      facts: ['KI-Agenten und MCP-Server', 'Suche und RAG über Unternehmensdaten', 'Erkennung von Dokumenten, Scans und Spezifikationen'],
      soon: 'Bald finden Sie hier Experimente und News des KI-Teams',
    },
    development: {
      name: 'Entwicklung',
      tagline: 'Systeme, die jahrelang laufen',
      about: 'Backend- und Frontend-Entwickler bauen nach vereinbarten Verträgen: Code-Review, Versionskontrolle und eine Architektur, die mit Last und neuen Funktionen wächst.',
      facts: ['Backend und Frontend in einem Team', 'Verpflichtendes Code-Review', 'Architektur für hohe Last'],
      soon: 'Bald finden Sie hier News und Tech-Highlights unserer Entwickler',
    },
    testing: {
      name: 'Testing',
      tagline: 'Fehler finden, bevor Kunden sie sehen',
      about: 'QA-Ingenieure testen Funktionen, Integrationen und Regressionen, automatisieren kritische Szenarien und führen vor jedem Release Lasttests durch.',
      facts: ['Funktions-, Integrations- und Regressionstests', 'Automatisierte Tests für kritische Abläufe', 'Lasttests vor dem Release'],
      soon: 'Bald finden Sie hier News und Challenges des QA-Teams',
    },
    devops: {
      name: 'DevOps',
      tagline: 'Schnell und stabil ausliefern',
      about: 'Automatische Builds und Deployments auf Test- und Produktivumgebungen, Monitoring, sichere Umgebungen und Skalierung — damit neue Versionen oft und ohne Überraschungen erscheinen.',
      facts: ['CI/CD für alle Umgebungen', 'Monitoring und Fehlerverfolgung', 'Clustering und Lastverteilung'],
      soon: 'Bald finden Sie hier News und Tipps des DevOps-Teams',
    },
  },
  projects: { platform: 'Distributionsplattform', grid: 'Digitales Stromnetz', panel: 'Umspannstationen in 10 Min.' },
  careers: { name: 'Offener Raum', lead: 'Ein Planet für alle, die mit uns Systeme bauen wollen. Jede offene Stelle ist eine eigene Mission.', mission: 'Mission annehmen →' },
  mission: {
    title: 'Mission „Von der Idee zum Release“',
    intro: 'Gehen Sie den Weg, den jedes unserer Projekte geht: Analyse → KI → Entwicklung → Testing → Start. Am Ende wartet eine Postkarte mit einem Wunsch zum Herunterladen.',
    progress: 'Etappen der Mission',
    locked: 'Diese Etappe öffnet sich nach dem Planeten',
    goTo: 'Dorthin fliegen',
    done: 'Etappe geschafft!',
    continueTo: 'Nächste Etappe:',
    analytics: {
      task: 'Aufgabe der Analyse: Wählen Sie 3 Karten — wie soll sich die Postkarte anfühlen?',
      cards: [
        { id: 'calm', label: 'Ruhe' }, { id: 'energy', label: 'Energie' }, { id: 'luck', label: 'Glück' },
        { id: 'team', label: 'Fürs Team' }, { id: 'bold', label: 'Mutige Ideen' }, { id: 'joy', label: 'Freude' },
      ],
      pick: 'Ausgewählt',
      confirm: 'Anforderungen freigeben',
    },
    ai: {
      task: 'Die KI hat aus Ihren Anforderungen Wünsche formuliert. Wählen Sie den besten.',
      generating: 'Das Modell denkt nach…',
      choose: 'Wählen',
      wishes: {
        calm: ['Möge Ihr Tag ruhig und jede Aufgabe lösbar sein.'],
        energy: ['Energie für den ganzen Tag — und noch ein bisschen für den Abend!'],
        luck: ['Möge heute alles beim ersten Versuch gelingen.'],
        team: ['Einen großartigen Tag für Sie und Ihr Team!'],
        bold: ['Mögen mutige Ideen heute zu Plänen werden.'],
        joy: ['Mehr Gründe zum Lächeln — schon heute!'],
      },
      fallback: ['Einen schönen Tag und leichte Aufgaben!'],
    },
    development: {
      task: 'Bauen Sie die Postkarte aus fertigen Komponenten.',
      backgrounds: ['Tiefer Weltraum', 'Polarlicht', 'Orbit-Sonnenuntergang'],
      planets: ['Planet ABV', 'Ringriese', 'Blauer Mond'],
      bg: 'Hintergrund',
      planet: 'Planet',
      build: 'Build starten',
    },
    testing: {
      task: 'Finden Sie 3 Bugs im Build — tippen Sie direkt auf der Postkarte darauf.',
      found: 'Gefunden',
      bugs: ['ein Tippfehler im Text', 'ein verrutschter Planet', 'ein überflüssiger roter Stern'],
      allFound: 'Alle Bugs behoben — der Build ist bereit für das Release',
    },
    devops: {
      task: 'Alles getestet. Wir starten das Release!',
      countdown: 'Countdown',
      launch: 'Release starten',
      released: 'Release erfolgreich!',
    },
    postcard: {
      title: 'Ihre Postkarte ist fertig',
      nameLabel: 'Für wen ist die Karte',
      namePlaceholder: 'Name',
      from: 'mit Grüßen aus dem ABV-Develop-System',
      download: 'Postkarte herunterladen',
      share: 'Link zur Website kopieren',
      copied: 'Link kopiert',
      again: 'Noch einmal spielen',
      greeting: 'Einen schönen Tag',
    },
  },
  brief: {
    title: 'Flugauftrag',
    intro: 'Beschreiben Sie Ihre Aufgabe in vier Schritten — der Auftrag fliegt zu unserem Team, und wir melden uns zurück.',
    steps: ['Ziel', 'Fracht', 'Zeitplan', 'Crew'],
    destination: 'Welches System brauchen Sie?',
    destinations: [
      { id: 'erp', label: 'ERP / CRM', hint: 'Prozesse, Buchhaltung, Dokumente' },
      { id: 'catalog', label: 'Katalog & Suche', hint: 'B2B-Portal, große Sortimente' },
      { id: 'ai', label: 'KI-Agenten', hint: 'Automatisierung, MCP, Erkennung' },
      { id: 'engineering', label: 'Ingenieursystem', hint: 'Energie, Konfiguratoren, GIS' },
      { id: 'other', label: 'Etwas anderes', hint: 'wir finden es gemeinsam heraus' },
    ],
    cargo: 'Was ist im Projekt wichtig? Mehrfachauswahl möglich',
    cargoItems: ['Prozesse automatisieren', 'Integration mit anderen Systemen', 'Hohe Last', 'KI und Daten', 'Bestehendes System weiterentwickeln', 'Von null starten'],
    cargoNote: 'Ein paar Worte zur Aufgabe (optional)',
    timeline: 'Wann soll es losgehen?',
    timelines: ['So bald wie möglich', 'In 1–3 Monaten', 'In etwa einem halben Jahr', 'Wir informieren uns noch'],
    crew: 'Wen sollen wir kontaktieren?',
    name: 'Name',
    email: 'Geschäftliche E-Mail',
    message: 'Kommentar',
    next: 'Weiter',
    back: 'Zurück',
    launch: 'Anfrage senden',
    sending: 'Wird gesendet…',
    sent: 'Ihre Anfrage ist im Orbit! Wir antworten Ihnen in Kürze per E-Mail.',
    error: 'Senden fehlgeschlagen. Bitte versuchen Sie es erneut oder schreiben Sie an sales@abvdevelop.com.',
    summary: 'Flugauftrag von der Website',
  },
}
